import { useEffect } from "react";
import { clearLocalStorage } from "../storage";

// Login pages only: `?clear=1` on the URL wipes any leftover session/flow
// data before the user starts a fresh login attempt.
export function useClearStorageOnQueryParam(): void {
  useEffect(() => {
    if (new URLSearchParams(window.location.search).get("clear") === "1") {
      clearLocalStorage();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
}
